var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExchangeActive = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 4.823a.427.427 0 0 1 0 .623l-1.247 1.211-2.805 2.814a.454.454 0 0 1-.632 0l-.935-.935a.454.454 0 0 1 0-.632l1.665-1.665H4.508a.445.445 0 0 1-.446-.472v-1.3a.436.436 0 0 1 .446-.436h7.524l-1.665-1.674a.445.445 0 0 1 0-.624L11.3.798a.445.445 0 0 1 .633 0l4.015 4.025ZM.627 13.276a.445.445 0 0 1 0-.624l1.211-1.3 2.725-2.831a.436.436 0 0 1 .623 0l.953.89a.436.436 0 0 1 0 .623l-1.62 1.746 7.532-.143a.445.445 0 0 1 .454.428v1.326a.436.436 0 0 1-.427.454l-7.515.179 1.7 1.602a.436.436 0 0 1 0 .624l-.89.952a.436.436 0 0 1-.623 0L.627 13.276Z",
    stroke: "#06061B",
    strokeMiterlimit: 10
  })));
};
export default SvgExchangeActive;